/**
 * @desc 线下学费码预下单
 */

import * as defs from '../../baseClass'
import axios from '@/services/request'

export class Params {}

export const init = new defs.SimpleResponse()

export async function request(params) {
  return axios({
    url: '/api/scp-cashier-business/payment/merchantQrCodePayment',
    data: params,
    method: 'post',
  })
}
